'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ProjectReport.scss');

var ProjectReportProgressProperty = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectReportProgressProperty, _Component);

  function ProjectReportProgressProperty() {
    (0, _classCallCheck3.default)(this, ProjectReportProgressProperty);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportProgressProperty.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportProgressProperty)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectReportProgressProperty, [{
    key: 'getValue',
    value: function getValue() {
      var _props = this.props,
          count = _props.count,
          countAll = _props.countAll,
          message = _props.message;

      return _react2.default.createElement(
        'div',
        { className: styles.progressContainer },
        _react2.default.createElement(_components.ProgressStatus, { count: count, countAll: countAll, containerClassName: styles.progressStatusContainer }),
        message
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var title = this.props.title;

      var progressValue = this.getValue();

      return _react2.default.createElement(_components.ProjectReportProperty, { title: title, value: progressValue });
    }
  }]);
  return ProjectReportProgressProperty;
}(_react.Component), _class.propTypes = {
  count: _propTypes2.default.number,
  countAll: _propTypes2.default.number,
  message: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.number]),
  title: _propTypes2.default.string
}, _temp);
exports.default = ProjectReportProgressProperty;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectReport/ProjectReportProgressProperty.js
// module id = 2057
// module chunks = 1